const user_scopes = {
    USER_GET : 'user:user:get', // '/user/id'
    USER_LIST : 'user:user:list', // '/users'
    SUPERIOR_LIST : 'user:superior:list', // '/user/id/superiors'
};

export default user_scopes;
